export default __webpack_public_path__ + "static/media/insta.32bda64b.png";